module.exports = "pegasus_template/assets/image-preview.png";